import { PrintJson } from "../../../theme/Component/PrintJson";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _BudgetCDPreductionFactory } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
interface Props {
    data: any;
    onChange: Function;
}
export const GenerateTraslate = ({ data, onChange }: Props) => {

    const _budget = useDataBean(_BudgetCDPreductionFactory);
    const [responseDocument, setResponseDocument] = useState<any>([]);

    useEffect(() => {


        if (data.TypeTraslate == 0) {
            generateReservaPresupuestal();
        }
        else if (data.TypeTraslate == 1) {
            generateCuentasPorPagar();
        }
        else {
            toast.error("Tipo de traslado no valido");
        }
    }, [data])

    const generateReservaPresupuestal = () => {
        _budget.instance.createBudgetReserve(data.Year, data.YearTO, data.Type, filterList(), data.Observation, _single.getAccountID()).then((res) => {
            toast.success("Reserva presupuestal generada");
            setResponseDocument(res);
        }).catch((err) => {
            toast.error("Error al generar la reserva presupuestal");
        })

    }
    const generateCuentasPorPagar = () => {
        _budget.instance.createBudgetPaymentAccount(data.Year, data.YearTO, data.Type, filterList(), data.Observation, _single.getAccountID()).then((res) => {
            toast.success("Cuentas por pagar generadas");
            setResponseDocument(res);
        }).catch((err) => {
            toast.error("Error al generar las cuentas por pagar");
        })
    }

    const filterList = () => {
        return data.List.filter((item) => item).map(item => item.IDDocument);
    }

    return (
        <div>
            <h6>Documentos generados</h6>
            {/* <PrintJson json={data} /> */}
            {/* <PrintJson json={responseDocument} /> */}
            {responseDocument.length > 0 ? (
                <div className="row">
                    <div className="col-md-12">
                        {responseDocument.map((item: any, index: number) => (
                            <div key={index}>
                                <p>{item}</p>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="row">
                    <div className="col-md-12">
                        <p>No hay documentos para trasladar</p>
                    </div>
                </div>
            )}
        </div>
    )
}